import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

/**
 * @summary RosterSummaryBlock
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('roster-summary-block')
class RosterSummaryBlock extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of RosterSummaryBlock.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'roster-summary-block';

  @property({type: Object, attribute: false})
  rosterSummary = {
    create: 0,
    delete: 0,
    update: 0,
    skip: 0,
    no_update: 0,
  };

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default RosterSummaryBlock;
